export default __webpack_public_path__ + "static/media/no-data-icon.0cadfc18.svg";